var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCorsevideo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.00006 0.560059C3.44647 0.560059 0.560059 3.44647 0.560059 7.00006C0.560059 10.5537 3.44647 13.4401 7.00006 13.4401C10.5537 13.4401 13.4401 10.5537 13.4401 7.00006C13.4401 3.44647 10.5537 0.560059 7.00006 0.560059ZM7.00006 1.12006C10.2507 1.12006 12.8801 3.74943 12.8801 7.00006C12.8801 10.2507 10.2507 12.8801 7.00006 12.8801C3.74943 12.8801 1.12006 10.2507 1.12006 7.00006C1.12006 3.74943 3.74943 1.12006 7.00006 1.12006ZM11.4757 6.71568C11.3215 6.71897 11.1979 6.84584 11.2001 7.00006C11.2001 9.32318 9.32318 11.2001 7.00006 11.2001C6.89943 11.199 6.80537 11.2515 6.75396 11.339C6.70365 11.4265 6.70365 11.5337 6.75396 11.6212C6.80537 11.7087 6.89943 11.7612 7.00006 11.7601C9.62615 11.7601 11.7601 9.62615 11.7601 7.00006C11.7612 6.92459 11.7316 6.85131 11.678 6.79772C11.6244 6.74412 11.5512 6.71459 11.4757 6.71568Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCorsevideo);
export default __webpack_public_path__ + "static/media/corsevideo.76afa8fec5fb97f7b7ba43d135774b5c.svg";
export { ForwardRef as ReactComponent };